import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { Image } from '@bd/bdcore-utilities';
import { colors, typography } from '../styles';

const styles = css`
  width: 400px;
  margin: 20px;
  display: flex;
  flex-direction: column;
  transition: all .3s ease;
  &:hover {
    @media(min-width: 992px) {
      transform: scale(1.05);
    }
  }
  .SpecialCard_media {
    position: relative;
    margin: 0 0 30px 0;
  }
  .SpecialCard_image {
    width: 100%;
  }
  .SpecialCard_button {
    position: absolute;
    right: 15px;
    bottom: -25px;
    width: 50px;
    height: 50px;
    z-index: 2;
    background-image: url('/images/icon-circle-arrow-right-white.svg');
    background-size: cover;
  }
  .SpecialCard_title {
    font-weight: 700;
    font-size: 21px;
    color: ${colors.white};
    font-family: ${typography.Condensed};
    @media(min-width: 992px) {
      font-size: 26px;
    }
  }
`;

function SpecialCard({ special }) {
  return (
    <Link
      name="special-offers-detail"
      params={{ title: get(special, 'headline') }}
      className={styles}
    >
      <div className="SpecialCard_media">
        <Image
          src={get(special, 'image.contentUrl')}
          alt={get(special, 'image.name', get(special, 'image.caption', ''))}
          className="SpecialCard_image"
          preserve
        />
        <div className="SpecialCard_button" />
      </div>
      <h4 className="SpecialCard_title">{get(special, 'headline')}</h4>
    </Link>
  );
}

SpecialCard.propTypes = {
  special: PropTypes.object.isRequired,
};

export default SpecialCard;



// WEBPACK FOOTER //
// ./src/components/SpecialCard.js